export default __webpack_public_path__ + "static/media/medtronic6xG.870a96d1.png";